<template>
  <GcBaseLayout
    :title="'Production Schedule'"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="false"
    :backButtonFunction="undefined"
    :formsConfig="formsConfig"
    :tabs="getBranchTabs"
    :selectedIndex="selectedTabIndex"
    ref="gc-base-layout"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Production Schedule'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Production Schedule'"
        :secondaryLabel="undefined"
      />
    </template>

    <div class="gc-syncfusion production-calendar">
      <div class="main-content" v-if="loaded">
        <div>
          <DxTabs
            :selected-index="SelectedProcessTab"
            :items="getProcessTabs"
            :orientation="'horizontal'"
            :styling-mode="'secondary'"
            :keyExpr="'id'"
            :element-attr="{
              class: 'process-tabs',
            }"
            :scrollByContent="true"
            :showNavButtons="true"
          />
        </div>
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <div>
              <DxTabs
                :selected-index="SelectedScheduleTab"
                :items="[
                  {
                    id: 0,
                    text: 'Work Orders',
                  },
                  {
                    id: 1,
                    text: 'Linked Sales Orders',
                  },
                ]"
                :orientation="'horizontal'"
                :styling-mode="'secondary'"
                :width="'auto'"
                :keyExpr="'id'"
                @itemClick="onScheduleTabChanged"
              />
            </div>
            <div class="button-toolbar">
              <div>
                <DxDropDownButton
                  text="Add New"
                  type="default"
                  styling-mode="contained"
                  class="button-full-width margin-right-5 override-styles"
                  icon="plus"
                  width="100"
                  :visible="SelectedScheduleTab === 0"
                  :onItemClick="addNewWorkOrder"
                  :items="getAddNewItems"
                  keyExpr="value"
                  displayExpr="text"
                  :drop-down-options="{ width: 150 }"
                />
              </div>
              <div>
                <DxButton
                  type="normal"
                  styling-mode="contained"
                  class="button-full-width override-styles"
                  icon="filter"
                  width="30"
                  v-if="!showRightContainer"
                  @click="openFilterPanel()"
                />
              </div>
            </div>
            <ejs-schedule
              :id="'ejs-schedule'"
              :height="height"
              :width="width"
              :views="views"
              :showQuickInfo="isTablet"
              :selectedDate="selectedDate"
              :eventSettings="getEventSettings"
              :popupOpen="onPopupOpen"
              :eventClick="onEventClick"
              :dragStart="onDragStart"
              :dragStop="onDragStop"
              ref="scheduleObj"
              :timeScale="{
                enable: SelectedScheduleTab === 0,
              }"
              :eventRendered="onEventRendered"
              :allowDragAndDrop="
                SelectedScheduleTab === 0 ||
                (SelectedScheduleTab === 1 && currentView !== 'Day')
              "
              @navigating="onNavigating"
              :workHours="{ highlight: true, start: '00:00', end: '00:00' }"
              :showAllDayRow="false"
            >
              <e-views>
                <!-- Day View Tiles -->
                <e-view
                  option="Day"
                  dateFormat="dd-MMM-yyyy"
                  :eventTemplate="'dayEventTemplate'"
                >
                  <template v-slot:dayEventTemplate="{ data }">
                    <CalendarDayTile
                      :data="data"
                      v-if="SelectedScheduleTab === 0"
                    />

                    <SODayTile :data="data" v-else />
                  </template>
                </e-view>

                <!-- Time Line Day Tiles -->
                <e-view option="TimelineDay"> </e-view>

                <!-- Week View Tile -->
                <e-view
                  option="Week"
                  dateFormat="dd-MMM-yyyy"
                  :eventTemplate="'weekEventTemplate'"
                >
                  <template v-slot:weekEventTemplate="{ data }">
                    <CalendarWeekTile
                      :data="data"
                      v-if="SelectedScheduleTab === 0"
                    />
                    <SOWeekTile :data="data" v-else />
                  </template>
                </e-view>

                <!-- Work Week View Tile -->
                <e-view
                  option="WorkWeek"
                  dateFormat="dd-MMM-yyyy"
                  :eventTemplate="'workEventTemplate'"
                >
                  <template v-slot:workEventTemplate="{ data }">
                    <CalendarWeekTile
                      :data="data"
                      v-if="SelectedScheduleTab === 0"
                    />
                    <SOWeekTile :data="data" v-else />
                  </template>
                </e-view>

                <!-- Month View Tile -->
                <e-view option="Month" :eventTemplate="'monthEventTemplate'">
                  <template v-slot:monthEventTemplate="{ data }">
                    <CalendarMonthTile
                      :data="data"
                      v-if="SelectedScheduleTab === 0"
                    />
                    <SOMonthTile :data="data" v-else />
                  </template>
                </e-view>
              </e-views>
              <!-- main tile template  -->

              <!-- tooltip template  -->
              <template v-slot:tooltipTemplate="{ data }">
                <WOToolTip :data="data" v-if="SelectedScheduleTab === 0" />
                <SOToolTip :data="data" v-else />
              </template>
            </ejs-schedule>
          </template>
          <template #rightContent>
            <gc-filter-panel
              :toolbarVisible="true"
              :toolbar="filterToolbar"
              :formItemData="filterFormItems"
              :setGridPanelFilter="setGridPanelFilter"
              :gridFoolter="false"
              :showLoading="showLoading"
              :from="'transaction-screen'"
              :isNormal="false"
              :persistenceKey="undefined"
              :overWriteClear="true"
              :ref="'gc-filter-panel'"
              :heightAdjustment="36"
              :key="filterPanelIndex"
            >
            </gc-filter-panel>
          </template>
        </gc-filter-split-view>
      </div>

      <GcPopUpWorkOrder
        :popupConfig="popupConfig"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-work-order',
        }"
        :data-model="dataModel"
        :show-loading="showLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerError"
        v-if="popupConfig.isPopupShow && !IsMaintenanceMode"
      />

      <GcPopupMaintenanceOrder
        :popupConfig="popupConfig"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-maintenance-order',
        }"
        :data-model="dataModel"
        :show-loading="showLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerError"
        v-if="popupConfig.isPopupShow && IsMaintenanceMode"
      />
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  DragAndDrop,
  ViewDirective,
  ViewsDirective,
  TimelineViews,
} from "@syncfusion/ej2-vue-schedule";

import { ProductionCalendarService } from "../../_services/api/production/production-calendar.service";
import { ProductionCalendarLinkedSOService } from "../../_services/api/production/production-calendar-linked-so";
import { getCalendarFilterValues } from "../../_helpers/calendar/filter-panel";

import { DataManager, ODataV4Adaptor } from "@syncfusion/ej2-data";
import { FeatureStorage, TokenStorage } from "../../_services/storage";
import appConfig from "../../app-config";
import { WorkOrderService } from "@/_services/api/production/work-order.service";
import { formatNumber } from "devextreme/localization";
import CalendarDayTile from "../../components/production/work-order/calendar-day-tile.vue";
import CalendarWeekTile from "../../components/production/work-order/calendar-week-tile.vue";
import CalendarMonthTile from "../../components/production/work-order/calendar-month-tile.vue";
import WOToolTip from "../../components/production/work-order/wo-tool-tip.vue";

// Tiles for Linked SOs
import SODayTile from "../../components/production/linked-sales-orders/so-day-tile.vue";
import SOWeekTile from "../../components/production/linked-sales-orders/so-week-tile.vue";
import SOMonthTile from "../../components/production/linked-sales-orders/so-month-tile.vue";
import SOToolTip from "../../components/production/linked-sales-orders/so-tool-tip.vue";
import { BranchService } from "../../_services/api/sales/branch.service";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import sortProcesses from "../../_helpers/calendar/scheduler-process";

import GcPopupMaintenanceOrder from "../../popups/maintenance-order/gc-popup-maintenance-order";

function getRandomHexColor() {
  const randomColor = Math.floor(Math.random() * 0xffffff).toString(16);
  return `#${randomColor.padStart(6, "0")}`;
}

function normalizeEvents(events) {
  return events.map((ev) => {
    const start = new Date(ev.startTime);
    const end = new Date(ev.endTime);
    const diff = end.getTime() - start.getTime();

    // exactly 24h (or 1 day in ms)
    if (diff === 24 * 60 * 60 * 1000) {
      // adjust EndTime back to 23:59:59 of same day
      const fixedEnd = new Date(start);
      fixedEnd.setHours(23, 59, 59, 999);

      return {
        ...ev,
        endTime: fixedEnd,
        IsAllDay: false, // make sure it's forced into time scale
      };
    }

    return ev;
  });
}

class WorkOrderAdaptor extends ODataV4Adaptor {
  processResponse() {
    let original = super.processResponse.apply(this, arguments);

    const scheduleElement = document.getElementById("ejs-schedule");
    const currentView =
      scheduleElement && scheduleElement.ej2_instances[0]
        ? scheduleElement.ej2_instances[0].currentView
        : "Unknown";

    original.forEach((item) => {
      item.subject = item.WorkOrderCode;
      item.startTime = new Date(item.StartDate.toISOString().replace("Z", ""));
      item.endTime =
        currentView == "Month"
          ? new Date(item.StartDate.toISOString().replace("Z", ""))
          : new Date(item.EndDate.toISOString().replace("Z", ""));
      item.IsAllDay = false;
      item.backGround = getRandomHexColor();
      item.IsBlock =
        item.WOType !== "Production" && item.WOType !== "Maintenance";
    });

    original = normalizeEvents(original);

    return original;
  }
}
class LinkSOAdaptor extends ODataV4Adaptor {
  processResponse() {
    let original = super.processResponse.apply(this, arguments);

    original.forEach((item, index) => {
      // Convert to a fixed-time string, preserving the original timezone
      let dateObj = new Date(item.SalesOrderShipDate);
      item.SalesOrderShipDate = dateObj.toISOString().replace("Z", "");

      item.id = index + 1;
      item.subject = item.WorkOrderCode;
      item.startTime = new Date(item.PackDate).toFilterDateStartTime();
      item.endTime = new Date(item.PackDate).toFilterDateEndTime();
      item.IsAllDay = true;
      item.backGround = getRandomHexColor();

      if (!item.TransportStatusHexColour)
        item.TransportStatusHexColour = "#800080";
    });

    return original;
  }
}

let draggedEvent = null;
// let draggedElement = null;
let refreshLayout = null;

export default {
  mixins: [RouteMixin, FormMixin],
  provide: {
    schedule: [Day, Week, WorkWeek, Month, Agenda, DragAndDrop, TimelineViews],
  },
  components: {
    "e-views": ViewsDirective,
    "e-view": ViewDirective,
    CalendarDayTile,
    CalendarWeekTile,
    CalendarMonthTile,
    WOToolTip,
    SODayTile,
    SOWeekTile,
    SOMonthTile,
    SOToolTip,
    GcPopupMaintenanceOrder,
  },
  data() {
    return {
      tabInfo: [],
      selectedIndex: 0,
      showLeftContainer: true,
      showRightContainer: true,
      loaded: false,
      height: "auto",
      width: "100%",
      views: ["Day", "Week", "WorkWeek", "Month"],
      selectedDate: new Date(),
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            this.$nextTick(() => {
              this.rePaintSchedule();

              this.$nextTick(() => {
                this.fetchWorkHours();
              });
            });
          },
        },
      },
      filterValues: false,
      ProcessCode: undefined,
      popupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        toolbarMenuItems: [
          {
            menuText: "Copy",
            visible: false, // pending discussions #54331
          },
          { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
          { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
          { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
        ],
        formMode: "create",
        isEditable: false,
        calendarDate: undefined,
        workOrderCode: undefined,
      },
      dataModel: undefined,
      SelectedScheduleTab: 0,
      SelectedProcessTab: 0,
      currentView: undefined,
      branchTabs: [],
      processTabs: [],
      BranchCode: undefined,
      filterPanelIndex: 0,
      IsMaintenanceMode: false,
    };
  },
  async beforeCreate() {
    await BranchService.getManufactureBranch().then((res) => {
      res.data.value.forEach((element) => {
        this.branchTabs.push({
          BranchCode: element.Code,
          text: element.Code + " - " + element.Description,
          path: `/production-calendar/` + element.Code,
          applicationFeatureCode: "ProductionSchedule",
          onClick: this.onBranchChanged,
        });
      });
    });

    let processTabs = [];

    await ProductionCalendarService.getProductionProcess().then((res) => {
      res.data.value.forEach((element, index) => {
        processTabs.push({
          id: index,
          code: element.Code,
          text: element.Description,
          applicationFeatureCode: "ProductionSchedule",
          onClick: this.onProcessChanged,
        });
      });
    });

    let definedSortOrder = [];
    let defaultSortOrder = undefined;

    let PSDefinedSortOrder = await SettingsService.getBySettingName(
      "ProductionScheduleDefinedSortOrder"
    );

    if (PSDefinedSortOrder && PSDefinedSortOrder.data.value.length > 0) {
      definedSortOrder = PSDefinedSortOrder.data.value[0].SettingValue.split(
        ","
      ).map((item) => item.trim());
    }

    let PSDefaulSortOrder = await SettingsService.getBySettingName(
      "ProductionScheduleDefaulSortOrder"
    );

    if (PSDefaulSortOrder && PSDefaulSortOrder.data.value.length > 0) {
      defaultSortOrder = PSDefaulSortOrder.data.value[0].SettingValue;
    }

    this.processTabs = sortProcesses(
      processTabs,
      definedSortOrder,
      defaultSortOrder
    );

    this.ProcessCode = this.processTabs[0].code;
    this.$nextTick(() => {
      this.fetchWorkHours();
    });

    if (this.baseView.id) {
      let index = this.branchTabs.findIndex(
        (x) => x.BranchCode === this.baseView.id
      );
      if (index !== -1) this.selectedIndex = index;
      this.BranchCode = this.baseView.id;
    } else {
      this.BranchCode = this.branchTabs[0].BranchCode;
    }
  },
  mounted() {
    setTimeout(() => {
      var scrollableView = document.getElementsByClassName(
        "layout-body dx-scrollview"
      );

      this.height = scrollableView[0].clientHeight - 65 - 74;
    }, 250);
  },
  async created() {
    this.loaded = true;

    this.$nextTick(() => {
      this.fetchWorkHours();
    });
  },
  methods: {
    async fetchWorkHours(autoScroll = true) {
      if (!this.ProcessCode || this.SelectedScheduleTab !== 0) return;
      const scheduleObj =
        document.getElementById("ejs-schedule").ej2_instances[0];
      let earliestStart = null;

      // Get the visible date range of the current view
      const visibleDates = scheduleObj.getCurrentViewDates();
      const startDate = visibleDates[0];
      const endDate = visibleDates[visibleDates.length - 1];

      try {
        const response = await ProductionCalendarService.getWorkHours(
          new Date(startDate).toFilterDateString(),
          new Date(endDate).toFilterDateString(),
          this.ProcessCode
        );

        if (
          response &&
          response.data &&
          response.data.value &&
          response.data.value.length > 0
        ) {
          scheduleObj.workHours.highlight = true;
          await this.rePaintSchedule();
          const workHours = response.data.value;

          await this.$nextTick();

          workHours.forEach((wh) => {
            // Dev only, remove timezone for dev purposes
            // wh.DateStart = wh.DateStart.replace("Z", "");
            // wh.DateEnd = wh.DateEnd.replace("Z", "");
            wh.ShiftDateStart = wh.ShiftDateStart.replace("Z", "");

            const start = new Date(wh.DateStart.replace("Z", ""));
            const end = new Date(wh.DateEnd.replace("Z", ""));

            const shiftDate = this.normalizeDate(wh.ShiftDateStart);

            // track earliest start time
            if (!earliestStart || start < earliestStart) {
              earliestStart = start;
            }

            if (start.toDateString() === end.toDateString()) {
              // Normal case: same day
              scheduleObj.setWorkHours(
                [shiftDate],
                this.formatTime(start),
                this.formatTime(end)
              );
            } else {
              // Cross-midnight case → split highlight

              // 1) Late evening on shift start day
              scheduleObj.setWorkHours(
                [shiftDate],
                this.formatTime(start),
                "23:59"
              );

              // 2) Early morning on next day
              const nextDay = new Date(shiftDate);
              nextDay.setDate(nextDay.getDate() + 1);
              scheduleObj.setWorkHours(
                [nextDay],
                "00:00",
                this.formatTime(end)
              );
            }
          });

          await this.$nextTick(() => {
            // after processing all work hours, scroll
            if (earliestStart && autoScroll) {
              this.scrollToWorkHoursStart(earliestStart);
            }
          });
        } else {
          scheduleObj.workHours.highlight = false;
          // No work hours → reset scroll to top (00:00)
          scheduleObj.scrollTo("00:00");
        }
      } catch (error) {
        this.displayServerError(error);
      }
    },
    formatTime(isoString) {
      const date = new Date(isoString); // converts UTC string to local time
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    },

    normalizeDate(isoString) {
      const d = new Date(isoString);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate()); // strip time
    },

    onScheduleTabChanged(e) {
      // Work Orders
      if (e.itemIndex === 0) {
        this.SelectedScheduleTab = 0;
        this.$nextTick(() => {
          this.rePaintSchedule();

          this.$nextTick(() => {
            this.fetchWorkHours();
          });
        });
      }
      // Linked Sales Orders
      else if (e.itemIndex === 1) {
        this.SelectedScheduleTab = 1;
        this.$nextTick(() => {
          this.rePaintSchedule();

          this.$nextTick(() => {
            this.fetchWorkHours();
          });
        });
      }
    },
    rePaintSchedule() {
      let scheduleObj =
        document.getElementById("ejs-schedule").ej2_instances[0];

      scheduleObj.refresh();
    },
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    /**
     * Open Filter Panel
     */
    openFilterPanel() {
      this.showRightContainer = true;
      this.$nextTick(() => {
        this.rePaintSchedule();

        this.$nextTick(() => {
          this.fetchWorkHours();
        });
      });
    },
    /**
     * Filter Panel values
     * @param e
     * @param valueChanged
     */
    setGridPanelFilter(e, valueChanged, filterType = "Apply") {
      if (valueChanged && filterType.toLowerCase() === "refresh") {
        this.onWorkOrderSave();
      } else {
        this.filterValues = getCalendarFilterValues(e, valueChanged);
      }
    },
    onBranchChanged(e) {
      if (e && e.BranchCode !== undefined && this.BranchCode !== e.BranchCode) {
        this.showLoading(true);
        let scheduleObj =
          document.getElementById("ejs-schedule").ej2_instances[0];

        if (scheduleObj) {
          this.filterValues = undefined;
          this.$refs["gc-filter-panel"].$refs["gc-form"].clearFormModel();
          //   scheduleObj.refresh();
          this.$nextTick(() => {
            this.BranchCode = e.BranchCode;
            setTimeout(() => {
              this.showLoading(false);
            }, 500);
          });
        } else this.showLoading(false);
      }
    },
    /**
     * dynamic tab value changed
     */
    onProcessChanged(e) {
      let item = e.itemData;
      if (item && item.code !== undefined && this.ProcessCode !== item.code) {
        this.showLoading(true);
        let scheduleObj =
          document.getElementById("ejs-schedule").ej2_instances[0];

        if (scheduleObj) {
          this.filterValues = undefined;
          this.$refs["gc-filter-panel"].$refs["gc-form"].clearFormModel();
          //   scheduleObj.refresh();
          this.$nextTick(() => {
            this.ProcessCode = item.code;
            setTimeout(() => {
              this.showLoading(false);
            }, 500);
          });
        } else this.showLoading(false);
      }

      this.$nextTick(() => {
        this.fetchWorkHours();
      });
    },

    /**
     * on default popup open event
     * @param args
     */
    async onPopupOpen(args) {
      if (args.type === "Editor" && this.SelectedScheduleTab === 0) {
        args.cancel = true;

        this.popupConfig.title = this.IsMaintenanceMode
          ? "Create Maintenance Order"
          : "Create Work Order";
        this.popupConfig.hideOnOutsideClick = false;
        this.popupConfig.workOrderCode = undefined;
        this.popupConfig.formMode = "create";
        await this.showEventCreateOrEditModal(args, args.data);
      }

      if (args.type === "Editor" && this.SelectedScheduleTab === 1) {
        args.cancel = true;
      }
    },

    /**
     * on event click event - by default event
     * @param args
     */
    async onEventClick(args) {
      if (args.name === "eventClick") {
        args.cancel = true;

        let data = (this.dataModel = args.event);
        if (data.WOType === "Down Time") return;

        this.showLoading(true);
        if (this.SelectedScheduleTab === 1) {
          data.FriendlyStatus = data.WorkOrderFriendlyStatus;
        }

        this.IsMaintenanceMode = data.WOType === "Maintenance";

        this.popupConfig.formMode = "review";
        this.popupConfig.hideOnOutsideClick = true;
        this.popupConfig.workOrderCode = data.WorkOrderCode;

        this.popupConfig.title = this.IsMaintenanceMode
          ? `Maintenance Order #${data.WorkOrderCode}`
          : `Work Order #${data.WorkOrderCode}`;
        this.popupConfig.secondaryTitle =
          data.ProductCode + " - " + data.ProductDescription1;
        this.popupConfig.isEditable =
          (data.FriendlyStatus === "Active" ||
            data.FriendlyStatus === "In Production") &&
          FeatureStorage.checkPermission(
            this.IsMaintenanceMode ? "MaintenanceOrder" : "WorkOrder",
            "edit"
          );

        const response = await WorkOrderService.getByCode(
          this.popupConfig.workOrderCode
        );
        this.dataModel = response.data.value[0];
        this.popupConfig.isPopupShow = true;

        // await this.showEventCreateOrEditModal(args, args.event);
      }
    },

    /**
     * on drag starts event
     */
    onDragStart(e, eventData) {
      // if (this.currentView === "Day" && e.e.srcElement.dataset.tooltipId)
      //    document.getElementById(
      //      e.e.srcElement.dataset.tooltipId
      //    ).style.display = "none";

      if (
        this.getPermissionToCreate == false &&
        e.data.FriendlyStatus !== "Draft" &&
        e.data.FriendlyStatus !== "Planning" &&
        e.data.FriendlyStatus !== "Awaiting Production" &&
        e.data.FriendlyStatus !== "Review"
      )
        e.cancel = true;

      if (e.data.WOType === "Down Time") e.cancel = true;

      draggedEvent = eventData;
    },

    /**
     * on drag stop event - this function get triggers in week, workweek and month view.
     * between diff dates
     * @param {Object} e - The event object associated with the drag stop.
     */
    async onDragStop(e) {
      e.cancel = true;
      if (this.SelectedScheduleTab === 1) {
        const isSameDate = (date1, date2) => {
          return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
          );
        };

        if (isSameDate(e.data.PackDate, e.data.startTime)) {
          return;
        }
      }

      if (e.data) {
        // this.showLoading(true);
        var model = e.data;
        // // update single event
        // let payload = {
        //   ProcessCode: this.ProcessCode,
        //   ScheduledDate: new Date(model.startTime).toSaveDate(),
        //   WorkOrderCode: model.WorkOrderCode,
        //   Comments: model.Comments,
        // };

        // await WorkOrderService.workOrderReschedule(payload)
        //   .then((res) => {
        //     if (res) this.showLoading(false);
        //     this.$notify(
        //       `Work order #${model.WorkOrderCode} is successfully updated.`,
        //       "success"
        //     );
        //     this.onWorkOrderSave();
        //   })
        //   .catch((err) => {
        //     if (err) this.showLoading(false);
        //     this.displayServerError(err);
        //   });

        if (this.SelectedScheduleTab === 0)
          this.reOrderWorkOrder({
            ProcessCode: this.ProcessCode,
            OldScheduledDate: new Date(
              model.StartDate.toISOString().replace("Z", "")
            ).toSaveDateTime(),
            NewScheduledDate: new Date(model.startTime).toSaveDateTime(),
            WorkOrderCode: model.WorkOrderCode,
            NewPosition: -1,
          });
        else {
          this.reOrderLinkSoLines({
            ProcessCode: this.ProcessCode,
            SalesOrderCode: model.SalesOrderCode,
            SalesOrderLine: model.SalesOrderLine,
            OldScheduledDate: new Date(model.PackDate).toSaveDate(),
            NewScheduledDate: new Date(model.startTime).toSaveDate(),
            WorkOrderCode: model.WorkOrderCode,
            NewPosition: -1,
          });
        }
      }
    },

    onEventRendered(args) {
      // args.element.style.height = "auto";
      setTimeout(() => {
        // if (args.element.previousElementSibling) {
        //   args.element.style.top = `${
        //     args.element.previousElementSibling.offsetHeight +
        //     args.element.previousElementSibling.offsetTop +
        //     5
        //   }px`;
        // }

        if (this.currentView === "Day") {
          let scheduleObj =
            document.getElementById("ejs-schedule").ej2_instances[0];
          const myDiv = document.querySelector(".e-content-wrap");

          if (this.hasVerticalScroll(myDiv) && !refreshLayout) {
            refreshLayout = true;
            scheduleObj.refreshLayout();
          }

          if (refreshLayout) args.element.classList.add("set-width");
        }
      }, 1 * args.data.Index);

      setTimeout(() => {
        // args.element.style.width = "100%";
      }, 100 * args.data.Index);

      if (args.data.IsAllDay && this.currentView === "Day") {
        args.element.draggable = true;
        args.element.addEventListener("dragstart", (e) =>
          this.onDragStart({ e, data: args.data }, args.data)
        );
        args.element.addEventListener("dragover", this.onDragOver);
        args.element.addEventListener("drop", (e) => this.onDrop(e, args.data));
      }
    },
    hasVerticalScroll(element) {
      return element.scrollHeight > element.clientHeight;
    },
    onDragOver(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
    },

    /**
     * on drag stop event - this function get triggers in day view
     * vertical drag & drop
     */
    onDrop(e, targetEventData) {
      e.preventDefault();

      if (this.SelectedScheduleTab === 0)
        this.reOrderWorkOrder({
          ProcessCode: this.ProcessCode,
          OldScheduledDate: new Date(targetEventData.startTime).toSaveDate(),
          NewScheduledDate: new Date(targetEventData.endTime).toSaveDate(),
          WorkOrderCode: draggedEvent.WorkOrderCode,
          NewPosition: targetEventData.Index + 1,
        });
      else {
        this.reOrderLinkSoLines({
          ProcessCode: this.ProcessCode,
          SalesOrderCode: draggedEvent.SalesOrderCode,
          SalesOrderLine: draggedEvent.SalesOrderLine,
          OldScheduledDate: new Date(draggedEvent.PackDate).toSaveDate(),
          NewScheduledDate: new Date(targetEventData.startTime).toSaveDate(),
          WorkOrderCode: draggedEvent.WorkOrderCode,
          NewPosition: targetEventData.Index + 1,
        });
      }
    },

    async reOrderLinkSoLines(payload) {
      this.showLoading(true);
      await ProductionCalendarLinkedSOService.reOrderLinkedSalesOrder(payload)
        .then(() => {
          this.showLoading(false);
          this.onWorkOrderSave();
        })
        .catch((err) => {
          this.showLoading(false);
          this.displayServerError(err);
        });
    },
    async reOrderWorkOrder(payload) {
      this.showLoading(true);
      await WorkOrderService.reOrderWorkOrder(payload)
        .then(async () => {
          this.showLoading(false);
          this.onWorkOrderSave(false);

          this.$nextTick(async () => {
            await this.fetchWorkHours(false);
            this.scrollToWorkHoursStart(payload.NewScheduledDate);
          });
        })
        .catch((err) => {
          this.showLoading(false);
          this.displayServerError(err);
        });
    },
    onNavigating(e) {
      if (e && e.currentView === "Month") {
        this.$nextTick(() => {
          let element = document.getElementsByClassName("e-content-wrap");
          if (element && element.length > 0) {
            element[0].style.setProperty("overflow-x", "hidden", "important");
          }
        });
      }

      if (e.action === "view") {
        this.currentView = e.currentView;
      }
      refreshLayout = false;

      this.$nextTick(() => {
        this.fetchWorkHours();
      });
    },

    scrollToWorkHoursStart(earliestStart) {
      const scheduleObj =
        document.getElementById("ejs-schedule").ej2_instances[0];
      if (!scheduleObj || !earliestStart) return;
      const scrollDate = new Date(earliestStart);
      scrollDate.setMinutes(scrollDate.getMinutes() - 30); // minus 30 mins

      const scrollTime = scrollDate.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      scheduleObj.scrollTo(scrollTime);
    },
    /**
     * add new WO event
     */
    addNewWorkOrder(e) {
      if (e.itemData) {
        e.itemData.value === "maintenance"
          ? (this.IsMaintenanceMode = true)
          : (this.IsMaintenanceMode = false);
      }

      let scheduleObj =
        document.getElementById("ejs-schedule").ej2_instances[0];

      let cellData = {
        data: {
          startTime: new Date(),
        },
        type: "Editor",
      };
      scheduleObj.popupOpen(cellData, "Editor");
    },

    async showEventCreateOrEditModal(args, eventData) {
      args.cancel = true;
      if (eventData) {
        if (this.getPermissionToCreate === false) args.cancel = true;
        else {
          this.dataModel = {
            StartDate: eventData.startTime,
          };

          this.popupConfig.calendarDate = eventData.startTime;
          this.popupConfig.isPopupShow = true;
        }
      }
    },
    /**
     * Hide A popup
     */
    onPopupHide() {
      this.IsMaintenanceMode = false;
      this.popupConfig.isPopupShow = false;
    },

    onWorkOrderSave(fetchWorkHours = true) {
      this.onPopupHide();
      this.showLoading(true);
      let scheduleObj =
        document.getElementById("ejs-schedule").ej2_instances[0];

      if (scheduleObj) {
        scheduleObj.refresh();
        this.$nextTick(() => {
          if (fetchWorkHours) {
            this.fetchWorkHours();
          }
          setTimeout(() => {
            this.showLoading(false);
          }, 500);
        });
      } else this.showLoading(false);
    },
  },
  computed: {
    getBranchTabs() {
      return this.branchTabs;
    },
    /**
     * Return user permission for the feature
     */
    getPermissionToCreate() {
      return FeatureStorage.checkPermission("WorkOrder", "create");
    },
    /**
     * Return event settings
     */
    getEventSettings() {
      return {
        dataSource: this.getDataManager,
        fields: {
          id: "Id",
          subject: { name: "subject" },
          description: { name: "Purpose" },
          startTime: { name: "startTime" },
          endTime: { name: "endTime" },
        },
        enableTooltip: true,
        // template: "eventTemplate",
        tooltipTemplate: "tooltipTemplate",
        // enableMaxHeight: true,
        // sortComparer: (args) => {
        //   args.sort((a, b) => a.Sequence - b.Sequence);

        //   return args;
        // },
      };
    },

    /**
     * returns the datasource manager for the scheduler
     */
    getDataManager() {
      if (this.filterValues == undefined || this.ProcessCode == undefined)
        return;

      let scheduleURL =
        this.SelectedScheduleTab === 0
          ? "ProductionScheduleWorkOrder"
          : "ProductionScheduleWorkOrderToSalesOrderLine";

      let filters =
        this.SelectedScheduleTab === 0
          ? `(ProcessCode eq '${this.ProcessCode}') and (BranchCode eq '${this.BranchCode}') and (FriendlyStatus ne 'Cancelled')&orderby=Sequence asc`
          : `(ProcessCode eq '${this.ProcessCode}') and (BranchCode eq '${this.BranchCode}') and (FriendlyStatus ne 'Cancelled')&orderby=WorkOrderSequence asc,Position asc`;

      let dataManager = new DataManager({
        url:
          appConfig.VUE_APP_ROOT_API +
          `/api/${scheduleURL}?${
            this.filterValues
              ? `&filter=((${this.filterValues}) or (WOType ne 'Production' and WOType ne 'Maintenance')) and ${filters}` // always show downtime slots regardless of filter (FriendlyStatus eq 'Active')
              : `&filter=${filters}`
          }`,
        adaptor:
          this.SelectedScheduleTab === 0
            ? new WorkOrderAdaptor()
            : new LinkSOAdaptor(),
        crossDomain: true,
      });

      dataManager.adaptor.beforeSend = function (dm, request) {
        request.setRequestHeader("x-tenant-id", TokenStorage.getTenant());
        request.setRequestHeader(
          "Authorization",
          `Bearer ${TokenStorage.getToken()}`
        );
      };

      return dataManager;
    },

    /**
     * Retun filter panel form items
     */
    filterFormItems() {
      return [
        {
          screenField: "Code",
          filterLabel: "Work Order",
          filterDataField: "WorkOrderCode",
          type: "Integer",
        },
        {
          screenField: "SalesOrder",
          gridDataField: "SalesOrderList",
          dataField: "SalesOrderList",
          filterDataField: "SalesOrderList",
          type: "Text",
        },
        {
          screenField: "Product",
          filterDataField: "ProductCode",

          filterOverWrites: {
            select: ["Code", "Description1", "Inactive", "Status", "Source"],
            filter: [
              ["Inactive", "=", "N"],
              "and",
              ["Status", "=", "A"],
              "and",
              ["Source", "=", "M"],
            ],
          },
        },
        {
          screenField: "BOM",
          filterDataField: "BomCode",
        },
        {
          screenField: "Status",
          filterDataField: "FriendlyStatus",
          dataSourceConfig: {
            endpoint: "api/WorkOrderStatus",
            sort: {
              selector: "Sequence",
              asc: true,
            },
            filter: [["Inactive", "=", "N"], "and", ["Code", "<>", "X"]],
            select: ["FriendlyStatus", "Sequence", "Inactive", "Code"],
          },
          editorTemplate: {
            primary: [
              {
                dataField: "FriendlyStatus",
              },
            ],
          },
          valueExpr: "FriendlyStatus",
          displayExpr: "FriendlyStatus",
        },
      ];
    },
    /**
     * return tab value
     */
    getProcessTabs() {
      return this.processTabs;
    },

    /**
     * return selected tab index
     */
    selectedTabIndex() {
      return this.selectedIndex;
    },

    getAddNewItems() {
      return [
        {
          text: "Work Order",
          value: "workorder",
          disabled: !this.getPermissionToCreate,
        },
        {
          text: "Maintenance Order",
          value: "maintenance",
          disabled: !FeatureStorage.checkPermission("MaintenanceOrder", "edit"),
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.production-calendar {
  .process-tabs {
    width: 100%;

    .dx-tabs-wrapper {
      display: flex;
      // div.dx-item.dx-tab:first-child {
      //   width: 150px;
      // }

      // div.dx-item.dx-tab:not(:first-child) {
      //   width: 150px;
      // }
    }
  }
  // .event-template {
  //   .description {
  //     text-wrap: wrap;
  //   }
  // }

  // .e-schedule .e-vertical-view.e-timescale-disable .e-appointment {
  //   height: auto !important;
  // }

  .e-schedule .e-month-view .e-current-date .e-date-header,
  .e-calendar .e-content td.e-selected span.e-day,
  .e-bigger.e-small .e-calendar .e-content td.e-selected span.e-day {
    background-color: #03a9f4 !important;
    border: 1px solid #03a9f4;
  }

  .e-btn.e-flat.e-primary,
  .e-css.e-btn.e-flat.e-primary,
  .e-active-view .e-tbar-btn-text,
  .e-current-day {
    color: #03a9f4 !important;
  }

  .e-schedule
    .e-vertical-view
    .e-day-wrapper
    .e-appointment
    .e-appointment-details {
    height: 100% !important;
    padding: 0px !important;
  }

  .e-schedule .e-vertical-view .e-work-cells {
    background: #f5f5f5;
  }

  .e-schedule .e-vertical-view .e-work-cells:hover {
    background: #ededed;
  }

  .e-schedule .e-vertical-view .e-work-hours {
    background: #ffffff;
  }

  .e-schedule .e-vertical-view .e-clone-time-indicator,
  .e-schedule .e-vertical-view .e-current-time {
    color: #03a9f4 !important;
  }

  .e-schedule .e-vertical-view .e-previous-timeline,
  .e-schedule .e-vertical-view .e-current-timeline {
    border-color: #03a9f4 !important;
  }

  .e-schedule .e-month-view .e-appointment,
  .e-schedule .e-vertical-view.e-timescale-disable .e-appointment {
    // background-color: #03a9f4 !important;

    background-color: unset;
    margin-bottom: 10px;

    .e-appointment-details {
      padding: unset;
      width: inherit;

      > div {
        width: 100%;
      }
    }
  }

  .e-schedule .e-month-view .e-appointment {
    height: 40px !important;

    .e-appointment-details {
      line-height: unset !important;
    }
  }

  .active {
    background: #62d26f;
  }

  .inproduction {
    background-color: #ffa500;
  }

  .completed {
    background-color: #4186e0;
  }

  .cancelled {
    background-color: #e8384f;
  }

  .e-block-appointment {
    display: flex;
    justify-content: center; /* horizontal center */
    align-items: center; /* vertical center */
    .template-wrap.downTime {
      span {
        color: #ffffff;
      }
    }
  }

  .downTime {
    // background-color: gray;
    // padding: 2px;
  }

  .e-more-popup-wrapper.e-popup.e-popup-open {
    .e-appointment {
      background: unset !important;
      line-height: unset !important;
    }
  }

  .e-content-wrap {
    width: 100%;
    overflow-y: auto;
    // overflow-x: hidden;
    box-sizing: border-box;
    .e-appointment-wrapper {
      width: 100%;
      .e-appointment {
        // width: 100% !important;
      }
      .e-appointment.set-width {
        // padding-right: 10px;
      }
    }
  }

  .e-table-wrap.e-week-view,
  .e-table-wrap.e-work-week-view,
  .e-table-wrap.e-day-view {
    .e-schedule-table.e-content-table {
      .e-appointment.e-lib.e-draggable {
        width: 100% !important;
        padding-left: 2px;
        padding-right: 2px;
        background: transparent;
        border-left: unset;
        border-right: unset;
      }
    }
  }

  // .e-schedule-table.e-content-table {
  //   td {
  //     border-color: rgba(0, 0, 0, 0.12) !important;
  //     border-style: solid !important;
  //     border-width: 0 0 1px 1px !important;
  //   }
  // }
}
</style>
